/** The audit log screen (docs/specs/audit.md). */
export const audit = {
    title: "Audit log",
    description: "Who changed what, and when. Entries can't be edited or deleted.",
    columns: { time: "Time", action: "Action", entity: "Record", actor: "By" },
    actor: { user: "User {{id}}", system: "System", device: "Device {{id}}", platform: "Platform support" },
    filters: {
        entity: "Record type",
        action: "Action",
        from: "From",
        to: "To",
        apply: "Apply",
        clear: "Clear",
    },
    empty: "No entries match these filters.",
    details: {
        title: "Entry details",
        before: "Before",
        after: "After",
        request: "Request ID",
        ip: "IP address",
        device: "Device",
    },
};
//# sourceMappingURL=audit.js.map